export default __webpack_public_path__ + "static/media/person_2.37f365fe.png";